<template>
	<div>
		<p>{{msg}}</p>
		
	</div>
</template>

<script>
	export default {
		data(){
			return {
				msg:''
			}
		},
		mounted(){
			document.title='温馨提示'
			this.msg = localStorage.getItem("message")
		}
	}
</script>

<style lang="less" scoped>
	p{
		text-align: center;
		margin-top: 30px;
		font-size: 36px;
	}
</style>
